import React from 'react';
import {FaCamera} from 'react-icons/fa';

function LaneCountCellRenderer({ value }) {
    return (
        <div className="flex items-center gap-1.5 h-full">
            <FaCamera className="text-gray-400 text-xs flex-shrink-0" />
            <span className="text-sm font-semibold">{value?.length ?? 0}</span>
        </div>
    );
}

export default LaneCountCellRenderer;
